import React from "react"
import { createGlobalStyle, ThemeProvider } from "styled-components"
import "./fonts.css"

import Header from "./header"
import Footer from "./footer"

// if (typeof window !== "undefined") {
//   // tslint-disable-next-line global-require
//   require("smooth-scroll")('a[href*="#"]', {
//     offset: 0,
//   })
// }

const theme = {
  breakpoints: {
    desktop: `992px`,
    large: `1140px`,
    phone: `576px`,
    tablet: `768px`,
  },
  colors: {
    primary: `#D33D17`,
    secondary: `#EED0C7`,
    accent: `#e73368`,
    light: `#F5F5F5`,
    dark: `#3C3C3B`,
    black: `#000000`,
    white: `#ffffff`,
  },
  fontBold: `"Pharma Bold", sans-serif`,
  fontGreen: `"Greengrocer", sans-serif`,
  fontTurmoil: `"Turmoil", sans-serif`,
  fontCondensed: `"Pharma Bold Condensed", sans-serif`,
  fontRegular: `"Pharma Bold Condensed", sans-serif`,
  fontLight: `"Eina Light", sans-serif`,
};

const Styles = createGlobalStyle`
  body{
    font-family: ${theme.fontBold};
    font-size: 1rem;
    line-height: 1.35;
    color: ${theme.colors.primary};
    margin: 0;
  }
  main {
        margin-top: 3rem;
        @media screen and (max-width: ${theme.breakpoints.tablet}) {
          margin-top: 3rem;
        }
        @media screen and (max-width: ${theme.breakpoints.phone}) {
          margin-top: 3rem;
        }
  }

  h1 {
    font-family: ${theme.fontBold};
    color: ${theme.colors.primary};
    font-size: 35px;
    @media screen and (max-width: ${theme.breakpoints.tablet}) {
      font-size: 30px;
    }
    @media screen and (max-width: ${theme.breakpoints.phone}) {
      font-size: 25px;
    }
    
  }

  h2 {
    font-size: 54px;
    font-family: ${theme.fontGreen};
    letter-spacing: 0.05rem;
    text-transform: uppercase;
    letter-spacing: 0.065em;
    word-spacing: 0.1em;
    color: ${theme.colors.primary};
    padding-bottom: 2rem;
    @media screen and (max-width: ${theme.breakpoints.phone}) {
      font-size: 30px;
      line-height: 1;
    }
  }
  h3 {
    font-size: 30px;
  }
  h4 {
    font-size: 20px;
  }
  h5 {
    font-family: ${theme.fontTurmoil};
    font-size: 1.5rem;
    letter-spacing: 0.04rem;
  }

  a {
    color: ${theme.colors.primary};
  }

  blockquote {
    

    margin: 0rem 0;
    padding: 0.5rem 0.5rem 0.5rem 60px;
    font-weight: bold;
    font-size: 30px;
    line-height: 1.2;
    padding: 0 !important;
    font-family: ${theme.fontTurmoil};
    letter-spacing: 0.03rem;
    @media screen and (max-width: ${theme.breakpoints.phone}) {
      background-position: 0rem 0.3rem;
      background-size: 25px auto;
      font-size: 22px !important;
      // p {
      //   padding-left: 2rem !important;
      // }
    }
  }


  svg {
    max-width: 100%;
  }
  .headroom {
    z-index: 2 !important;
  }
  .headroom--pinned header, .headroom--unpinned header {
    padding: 0.5rem 0 0.6rem;
    @media only screen and (max-width: ${theme.breakpoints.phone}) {
      padding: 1rem 0 0.5rem;
    }
    svg {
      width: 70px;
    }
  }
  .headroom--pinned {
    background-color: ${theme.colors.white};
    box-shadow: rgb(211 61 23 / 12%) -1px 3px 10px 1px;
    .hide {
      display: none;
    }
    ul {
      ul {  
        width: 100px;
        border-bottom: 2px solid ${theme.colors.primary};
        padding-bottom: 0.5rem !important;
      }
    }
  }
  @media only screen and (min-width: ${theme.breakpoints.tablet}) {
    // .home > .headroom--unfixed {
    //   svg {
    //     transition: 0.5s;
    //     transform-origin: 100% 0% 0px;
    //     transform: translate3d(49vw, 15vh, 0) scale3d(2, 2, 1);
    //   }
    // }
  }
`;

interface IProps {
  children: React.ReactNode
  headerClass?: string
}

const Layout = ({ children, headerClass }: IProps) => {
  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Styles />
        <Header headerClass={headerClass} />
        <main>{children}</main>
        <Footer />
      </React.Fragment>
    </ThemeProvider>
  )
}

export default Layout
